import React, { useEffect, useState } from "react";
import { Form, message, Space, Divider, Row, Col, Skeleton, Tooltip } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, TableComponent, ButtonComponent, SelectWithSearch, trans } from "@comps/components"
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { Commons, Const } from "../../constants";
import { getPreviewQueryReq, getReportTypesAndTables, getTableInfoByIdReq, updateDataReq } from "../requests";
import { createSelectList } from '@comps/commonFunctions';
import { PlayArrowOutlined } from "@mui/icons-material";
const langKey = Const["allReports"].lngKey
const formName = "updateReportName";

const UpdateReportName = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [reportTypes, setReportTypes] = useState([]);

  const [form] = Form.useForm()
  useEffect(() => {
    getRelatedData()
    setData()
    // eslint-disable-next-line
  }, []);

  const setData = () => {
    form.setFieldsValue(props.record)
  }


  //get report types and tables
  const getRelatedData = () => {
    makeRequestStateless(getReportTypesAndTables, null, onSuccessRelatedData, null);
  }
  const onSuccessRelatedData = (data) => {
    setReportTypes(createSelectList(data.report_types))
  }

  const onSubmit = (data) => {
    const payload = { ...props.record, ...data }
    payload.id = props.record.id
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    message.success("Saved Successfully");
    props.onCompleted(data.reports.data);
  }

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
    //setErrors(errorList);
  }


  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    !props.disabled &&
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1400 } maskClosable={ false }
      mainTitle={ trans(Commons.update) } subTitle={ trans(`${langKey}.rawReport`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ false }>

        <Form name={ formName } onFinish={ onSubmit } form={ form } disabled={ props.disabled }>
          <Row gutter={ 30 }>
            <Col lg={ 10 } sm={ 24 } xs={ 24 } >
              <Form.Item name="title" rules={ rules.name } label={ trans(`${langKey}.name`) }

              >
                <InputText placeholder="Name" />
              </Form.Item>
            </Col>

            <Col lg={ 10 } sm={ 24 } xs={ 24 } >
              <Form.Item name="report_type_id" label={ trans(`${langKey}.report_type_id`) } rules={ rules.report_type_id }
              >
                <SelectWithSearch

                  placeholder={ trans(`${langKey}.report_type_id`) }
                  options={ reportTypes } />
              </Form.Item>

            </Col>
          </Row>


        </Form>

      </Skeleton>

    </ModalComponent>
  )
}

export default UpdateReportName

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.required`) },
  ],
  report_type_id: [
    { required: true, message: trans(`${langKey}.report_type_id`) },
  ],
  schema_table_id: [
    { required: true, message: trans(`${langKey}.schema_table_id`) },
  ]
};
